import React from 'react'
import { gql } from 'apollo-boost'
import { Workflow } from './ow/model'
import { Notification } from './notifications/model'

export interface Restaurant {
  id: number
  name: string
  permalink: string
  locale: string
  workflow: Workflow
  notifications: Notification[]
  subscription_id: number
  settings: {
    pause_online_ordering: boolean
  }
  services: {
    id: string
    contact: {
      name: string
      email: string
      phone: string
    }
    label: string
  }[]
  timezone: {
    name: string
    offset: number
  }
  hours_of_operation: number[][][]
}

export const RestaurantCtx = React.createContext<Restaurant | null>(null)

export const GET_RESTAURANT_INFO = gql`
  query LoadRestaurantInfo($restaurant_id: Int!) {
    restaurant(id: $restaurant_id) {
      id
      permalink
      name
      workflow_uuid
    }
  }
`
export const GET_RESTAURANT_WORKFLOW = gql`
  query LoadRestaurantWorkflow($restaurant_id: Int!, $workflow_id: Int!) {
    restaurant(id: $restaurant_id) {
      id
      permalink
      name
      workflow_uuid
      workflow(id: $workflow_id) {
        id
        name
        author
        description
        uuid
        content {
          nodes {
            id
            name
            description
          }
        }
      }
    }
  }
`
export const GET_RESTAURANT = gql`
  query LoadRestaurant($restaurant_id: Int!, $workflow_id: Int!) {
    restaurant(id: $restaurant_id) {
      id
      permalink
      name
      hours_of_operation
      timezone {
        name
        offset
      }
      locale
      settings {
        pause_online_ordering
      }
      services {
        id
        contact {
          name
          phone
          email
        }
        label
      }
      notifications(workflow_id: $workflow_id) {
        id
        name
        disabled
        location_id
        service_type
        type
        workflow_nodes
        workflow_uuid
        outcomes {
          success
          failure
          accept
          reject
        }
        settings
      }
      subscription_id
      workflow(id: $workflow_id) {
        id
        name
        author
        description
        uuid
        content {
          nodes {
            id
            name
            description
            actions {
              name
              notes
              accept
              reject
              failure
              success
              params {
                event
                state
                template
                verb
              }
            }
          }
          transitions {
            from_node
            to_node
            name
            label
            category
            transition_type
            roles
            time {
              ref
              time_offset
              day_offset
            }
          }
        }
      }
    }
  }
`

export const GET_RESTAURANT_NOWF = gql`
  query LoadRestaurant($restaurant_id: Int!) {
    restaurant(id: $restaurant_id) {
      id
      permalink
      name
      hours_of_operation
      timezone {
        name
        offset
      }
      locale
      settings {
        pause_online_ordering
      }
      services {
        id
        contact {
          name
          phone
          email
        }
        label
      }
    }
  }
`
export const GET_RESTAURANT_WWF = gql`
  query LoadRestaurant($restaurant_id: Int!) {
    restaurant(id: $restaurant_id) {
      id
      name
      hours_of_operation
      timezone {
        name
        offset
      }
      locale
      settings {
        pause_online_ordering
      }
      services {
        id
        contact {
          name
          phone
          email
        }
        label
      }
    }
  }
`
